import script from "./talking-point.vue?vue&type=script&setup=true&lang=ts"
export * from "./talking-point.vue?vue&type=script&setup=true&lang=ts"

import "./talking-point.vue?vue&type=style&index=0&id=2cd98a1b&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cd98a1b"]])

export default __exports__